import React, { useContext, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { ItemList } from "./ItemList";
import Seo from "./Head";
import { CartContext } from "../context/CartContext";

const ItemListContainer = () => {
  const { nombreCategoria } = useParams();
  const { items, isLoading } = useContext(CartContext);

  // Scrollear al inicio al cambiar de categoría
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [nombreCategoria]);

  // 1. FILTRADO MEMOIZADO: Solo se recalcula si cambian los items o la categoría de la URL
  const productosCategoria = useMemo(() => {
    if (!items || items.length === 0) return [];

    return items.filter((p) => {
      const estaActivo = p.estado?.toLowerCase() !== "pausado";
      const noEsTaller = p.categoria?.toLowerCase() !== "talleres";

      // Caso: Tienda general
      if (
        !nombreCategoria ||
        nombreCategoria.toLowerCase() === "todos" ||
        nombreCategoria.toLowerCase() === "tienda"
      ) {
        return estaActivo && noEsTaller;
      }

      // Caso: Categoría específica (Comparación blindada)
      const slugProducto = String(p.categoria_slug || "")
        .toLowerCase()
        .trim();
      const slugURL = String(nombreCategoria).toLowerCase().trim();

      return estaActivo && slugProducto === slugURL;
    });
  }, [items, nombreCategoria]);

  // 2. NOMBRE DINÁMICO: Basado 100% en la URL para evitar saltos visuales al cargar
  const nombreDinamico = useMemo(() => {
    if (
      !nombreCategoria ||
      nombreCategoria.toLowerCase() === "todos" ||
      nombreCategoria.toLowerCase() === "tienda"
    ) {
      return "TIENDA DEL ESPACIO";
    }
    return nombreCategoria.replace(/-/g, " ").toUpperCase();
  }, [nombreCategoria]);

  // 3. PANTALLA DE CARGA
  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-dark" role="status">
          <span className="visually-hidden">Cargando catálogo...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Seo
        title={`Tienda - ${nombreDinamico}`}
        description="Rollos, químicos, revelado y cámaras analógicas."
        pathSlug={window.location.href}
      />

      <div className="container-fluid px-1 px-md-5 py-1 py-md-3">
        <div className="row">
          {productosCategoria.length > 0 ? (
            <div
              className="categorias-wrapper-tienda"
              style={{ "--categoria-nombre": `"${nombreDinamico}"` }}
            >
              <ItemList items={productosCategoria} />
            </div>
          ) : (
            <div className="text-center py-5">
              <h4>No hay productos en "{nombreDinamico}"</h4>
              <p className="text-muted">
                Verifica que la categoría sea la correcta.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ItemListContainer;
